import READ_MORE_ARROW from '../assets/read-more.svg';

export const READ_MORE_ICON_TYPES = {
  READ_MORE_ARROW,
};
